<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import LinkAccountCard from "../LinkAccountCard/LinkAccountCard.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig) || {};
//$: handleCallback = element?.data?.handleCallback as boolean || false;
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: connected = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.find(l => (l === null || l === void 0 ? void 0 : l.Type) === 'CLEAR') : null) || false;
//$: redirectURI = clientConfig?.redirectURI || new URL("/pages/en/ClearRedirect", document.baseURI).href;
const onConnect = () => {
    if (!connected) {
        //alert("calling ycSSOThirdPartyAuth: " + JSON.stringify(clientConfig));
        ycSSOThirdPartyAuth("CLEAR", clientConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            //alert("ycSSOThirdPartyAuth callback: " + JSON.stringify(clientResult));
            console.log(`ycSSOThirdPartyAuth callback inside ${method}`, method, clientResult);
            if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.authCode)) {
                console.warn(`ycSSOThirdPartyAuth callback for ${method}: no access token in client result`);
                return;
            }
            let result;
            f7.preloader.show('white');
            try {
                result = yield signonManager.linkWithClearAccount(clientResult.authCode, clientResult.callbackUrl, true);
            }
            finally {
                f7.preloader.hide();
            }
            if (result.success) {
                resolveUrl(`Connected?linkedImage=${encodeURIComponent('/static/icons/icon-clear.png')}`).func();
            }
            else {
                alert(((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UserMessage) === null || _b === void 0 ? void 0 : _b.Content) || 'An error occurred.');
            }
        }));
    }
    else {
        const url = `DisconnectAccounts?accountType=${"clear"}`;
        const resolved = resolveUrl(url);
        resolved.func();
    }
};
</script>

<CardBase {element}>
    <LinkAccountCard title='CLEAR' image={'/static/icons/icon-clear.png'} onConnect={onConnect} {connected} {sources} />        
</CardBase>
